module.exports = __webpack_public_path__ + "static/media/businessladies.f6662578.svg";